// extracted by mini-css-extract-plugin
export default {"main":"LoanAuditPage_main__RRzAp"};